import { useState } from "react";
import { TeachingFocusStep } from "../components/onboarding/TeachingFocusStep";
import { TeachingPrioritiesStep } from "../components/onboarding/TeachingPrioritiesStep";
import { TeachingRoleStep } from "../components/onboarding/TeachingRoleStep";
import { ONBOARDING_PRIORITY_SELECTION_MAX } from "../data/onboarding/teachingPriorities";
import { saveOnboardingProfile } from "../utils/onboarding/onboardingStorage";
import { savePinnedToolsFromOnboarding } from "../utils/onboarding/onboardingPinnedTools";

function toggleValue(list, value, maxItems = Infinity) {
  if (list.includes(value)) {
    return list.filter((item) => item !== value);
  }
  if (list.length >= maxItems) {
    return list;
  }
  return [...list, value];
}

export function OnboardingPage({ account, onComplete }) {
  const [step, setStep] = useState(1);
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [selectedGrades, setSelectedGrades] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [selectedCurricula, setSelectedCurricula] = useState([]);
  const [selectedPriorities, setSelectedPriorities] = useState([]);

  async function handleFinish() {
    const profile = {
      account,
      teachingRoleId: selectedRoleId,
      grades: selectedGrades,
      subjects: selectedSubjects,
      curricula: selectedCurricula,
      priorities: selectedPriorities,
      completedAt: new Date().toISOString(),
    };
    saveOnboardingProfile(profile);
    savePinnedToolsFromOnboarding(selectedPriorities);
    await onComplete?.({
      teachingRoleId: selectedRoleId,
      grades: selectedGrades,
      subjects: selectedSubjects,
      curricula: selectedCurricula,
      priorities: selectedPriorities,
    });
  }

  if (step === 1) {
    return (
      <TeachingRoleStep
        selectedRoleId={selectedRoleId}
        onSelectRole={setSelectedRoleId}
        onNext={() => setStep(2)}
      />
    );
  }

  if (step === 2) {
    return (
      <TeachingFocusStep
        selectedGrades={selectedGrades}
        selectedSubjects={selectedSubjects}
        selectedCurricula={selectedCurricula}
        onToggleGrade={(id) => setSelectedGrades((current) => toggleValue(current, id))}
        onToggleSubject={(id) =>
          setSelectedSubjects((current) => toggleValue(current, id))
        }
        onToggleCurriculum={(id) =>
          setSelectedCurricula((current) => toggleValue(current, id))
        }
        onBack={() => setStep(1)}
        onNext={() => setStep(3)}
      />
    );
  }

  return (
    <TeachingPrioritiesStep
      selectedPriorities={selectedPriorities}
      onTogglePriority={(id) =>
        setSelectedPriorities((current) =>
          toggleValue(current, id, ONBOARDING_PRIORITY_SELECTION_MAX),
        )
      }
      onBack={() => setStep(2)}
      onFinish={handleFinish}
    />
  );
}
